export enum ProjectParticipation {
    InvolvededProjects = 0,
    CanJoin = 1,
    AllProjects = 2,
}
